import {
  darkTheme,
  getThemeColorScheme,
  lightTheme,
  ThemeColorScheme,
} from "@avenue-8/sidekick-ui";
import { useAuthStore } from "@store/auth.store";

export const useTheme = (t?: ThemeColorScheme) => {
  const { theme } = useAuthStore((state) => state.preferences);
  const themeColorScheme = getThemeColorScheme(t ?? theme);
  return themeColorScheme === "dark" ? darkTheme : lightTheme;
};
